import { PercentageSymbolPipe } from './../../modules/shared/pipes/percentage-symbol.pipe';
import { SecsToDhmsPipe } from './../../modules/shared/pipes/secsToDhms.pipe';
import { TimeConvertPipe } from './../../modules/shared/pipes/timeConvert.pipe';
import { DateTimeOperatorValue } from './../../misc/saved-searches/models/saved-search.static';
import { ReportsAllFiltersApplyModes, ReportsAllFiltersAppyModels, typeReportsAllFiltersApplyModes } from './../models/reports-all-filter-appy.models';
import { Router } from '@angular/router';
import { myFavListData } from './../myfav-data';
import { ReportsMyFavList } from './../models/reports-myfav-list.model';
import { reportsMenuFlatData } from './../reports-menu.data';
import { ReportsFlatMenus } from './../models/reports-menu.model';
import { IReportsColumnModel } from './../models/reports.models';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AppMainComponent } from 'src/app/app.main.component';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
// import { LocalDatePipe } from 'src/app/shared/pipes/local-date.pipe';
import { LocalDatePipe } from 'src/app/modules/shared/pipes/local-date.pipe';
import { IDateFilterModel, IReportsFilterModel } from '../models/reports-filter.models';
import { DatePipe } from '@angular/common';
import { CurrencySymbolPipe } from 'src/app/modules/shared/pipes/currency-symbol.pipe';
import { MessageService } from 'primeng/api';
import { FINANCE_BALANCESHEET_DATE_RANGE_LIST } from 'src/app/modules/shared/constants/date-range-list.constants';
import { DateRangeFilterService } from 'src/app/modules/shared/services/date-range-filter.service';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    providers: [LocalDatePipe, TimeConvertPipe, SecsToDhmsPipe, CurrencySymbolPipe, PercentageSymbolPipe,]
})
export class FilterComponent implements OnInit, OnChanges {

    @Input() panelDialog: boolean;
    @Input() multiSelectFilter: boolean = false;
    @Input() showCardStyle: boolean = true;

    //#region @Input()
    private _filterByInput: IReportsColumnModel[] = [];
    //Filter By
    @Input() public set filterByInput(value: IReportsColumnModel[]) {
        this._filterByInput = value ?? [];
    };
    public get filterByInput(): IReportsColumnModel[] {
        return this._filterByInput;
    }

    private _filterByInputValue: any[] = [];
    //Options
    @Input() public set filterByInputValue(value: any) {
        this._filterByInputValue = value ?? [];
    };
    public get filterByInputValue(): any {
        return this._filterByInputValue;
    }

    @Input() selectedWindow: string = "";
    @Input() selectedFilterGroup: IReportsFilterModel[] = [];
    @Input() customDateFilters: any[] = [];
    @Input() customSeletedDateFilter: any = null;//Use for MyFav
    @Input() changeDateEnable = false;
    @Input() isShowAllDateFilter: boolean = false;//Shaw/Hide 'All' option on DateFilter Dropdown.
    @Input() hideDateFilter: boolean = false;
    @Input() dateRangeForDatetime: boolean = false;
    @Input() apiName;

    @Input() showChannelFilter: boolean = false;
    @Input() channelList = [];
    @Input() selectedChannel = null;
    @Input() showModuleFilter: boolean = false;
    @Input() moduleList = [];
    @Input() selectedModule = null;
    @Input() showWarehouseLocationFilter: boolean = false;
    @Input() warehouseLocationList = [];
    @Input() selectedWarehouseLocation = null;

    @Input() filterPopupOnly: boolean = false;
    @Input() displayFilterPopup: boolean = false;
    @Input() filterPopupHeader: string = "Filters";

    //Saved Search
    @Input() showGroupByFilter: boolean = false;
    @Input() savedGroup: any;
    @ViewChild('groupBy') groupBy: any;
    groupByFilter = [];
    groupByFilterCopy = [];
    aggregateFields = [];
    aggregateTypes = [
        { type: 'Total', code: 'Sum' },
        { type: 'Max', code: 'Max' },
        { type: 'Min', code: 'Min' },
        { type: 'Avg', code: 'Avg' },
        { type: 'Count', code: 'Count' }
    ];
    aggregateTypesCopy = [];
    selectedGroupBy: IReportsColumnModel;
    selectedSubGroupBy: IReportsColumnModel;
    selectedAggregateBy: IReportsColumnModel[] = [];
    selectedAggregateTypeBy: any = this.aggregateTypes[0];
    @Output() onGroupByFilter: EventEmitter<any> = new EventEmitter<any>();
    @Output() onResetGroupByFilter: EventEmitter<any> = new EventEmitter<any>();

    //Saved Search Order By
    @Input() showOrderByFilter: boolean = false;
    @Input() savedOrderBy: any;
    @ViewChild('orderBy') orderBy: any;
    orderByTypes = [
        { id: 1, isDescending: false, name: 'Ascending' },
        { id: 2, isDescending: true, name: 'Descending' }
    ];
    selectedOrderByType: any = null;
    selectedOrderField: any = null;
    topNumberOfRecords: number | null = null;
    topNumberOfRecordsDisabled: boolean = false;
    @Output() onOrderByFilter: EventEmitter<any> = new EventEmitter<any>();
    @Output() onResetOrderByFilter: EventEmitter<any> = new EventEmitter<any>();

    //Opportunity Channel
    @Input() showOpportunityChannelFilter: boolean = false;
    @Input() opportunityChannelList = [];
    @Input() selectedOpportunityChannel = null;
    @Input() enableAPIFilter: boolean = false;// Filter will applied on API call
    //#endregion

    //#region territory map
    @Input() showTerritoryChannelFilter: boolean = false;
    @Input() territoryNamesList = [];
    @Output() onSelectedTerritoryChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() onSelectedTerritory: EventEmitter<any> = new EventEmitter<any>();
    @Output() onTerritoryChangeChannel: EventEmitter<any> = new EventEmitter<any>();
    @Input() selectedTerritory: any = null;
    oldSelectedTerritory: any = null;
    //#endreion

    //#region @Output()
    @Output() onAllFilterApply: EventEmitter<ReportsAllFiltersAppyModels> = new EventEmitter<ReportsAllFiltersAppyModels>();
    @Output() onApplyFilter: EventEmitter<any> = new EventEmitter<any>();
    @Output() onChangeRange: EventEmitter<any> = new EventEmitter<any>();
    @Output() onClosePanel: EventEmitter<any> = new EventEmitter<any>();
    @Output() onRemoveFilter: EventEmitter<any> = new EventEmitter<any>();
    @Output() onModifyFilterOptions: EventEmitter<any> = new EventEmitter<any>();
    @Output() onChangeChannel: EventEmitter<any> = new EventEmitter<any>();
    @Output() onChangeModule: EventEmitter<any> = new EventEmitter<any>();
    @Output() onOpportunityChangeChannel: EventEmitter<any> = new EventEmitter<any>();
    @Output() onWarehouseLocation: EventEmitter<any> = new EventEmitter<any>();

    @Output() onCloseFilterPopup: EventEmitter<any> = new EventEmitter<any>();
    @Output() onOptionsFilter: EventEmitter<any> = new EventEmitter<any>();
    //#endregion

    //#region Properties
    filterDataByTime: IDateFilterModel[] = [];
    selectedDateFilter: IDateFilterModel;
    dateFrom = new Date();
    selectedDateFrom = null;
    dateFromMaxDate = new Date();
    selectedDateTo = null;
    dateTo = new Date();
    minDate = new Date();
    dateRangeTo = new Date();
    dateRangeFrom = new Date();

    filterGroup: IReportsFilterModel[] = [];
    filterBy = [];
    filterByCopy = [];
    selectedFilterBy: IReportsColumnModel;
    filterOptions = [];
    vertualFilterOptions = [];
    selectedFilterOption: any;
    currentEditedFilter: IReportsFilterModel = null;
    @ViewChild('op') op: any;
    showSub = false;
    addFilter = true;
    filterTemp: any;
    filterId = 0;
    editFlag: boolean = false;
    //#endregion

    reportsMenusFlat: ReportsFlatMenus[] = reportsMenuFlatData();
    myFavList: ReportsMyFavList[] = myFavListData as any;

    fav = [
        { id: 0, name: "Select Fav" }
    ];

    displayAddFav = false;
    selectedGroup;
    reportName;
    groups = [
        { id: 1, name: "New Group" },
        { id: 2, name: "Group 1" },
        { id: 3, name: "Group 2" },
    ];
    displayAddGroup = false;
    groupName;


    reportsAllFiltersApplyModes = ReportsAllFiltersApplyModes;
    tempFiltersValues: any;
    optionFilterText: string = "";

    //CTOR
    constructor(
        public app: AppMainComponent,
        public localDatePipe: LocalDatePipe,
        public datePipe: DatePipe,
        private timeConvert: TimeConvertPipe,
        private secsToDhms: SecsToDhmsPipe,
        private currencySymbol: CurrencySymbolPipe,
        private percentageSymbol: PercentageSymbolPipe,
        private router: Router,
        private messageService: MessageService,
        private dateRangeFilterService: DateRangeFilterService,

    ) {
        //set timezone date
        this.dateFrom = this.app._showDateTimeWithZone(new Date());
        this.dateFromMaxDate = this.app._showDateTimeWithZone(new Date());
        this.dateTo = this.app._showDateTimeWithZone(new Date());
        this.minDate = this.app._showDateTimeWithZone(new Date());
        this.dateRangeFrom = this.app._showDateTimeWithZone(new Date());
        this.dateRangeTo = this.app._showDateTimeWithZone(new Date());
    }

    ngOnChanges(changes: SimpleChanges): void {
        //remove filterGroup
        if (changes?.selectedWindow?.currentValue) {
            this.selectedWindow = changes?.selectedWindow?.currentValue;
            this.generateMyFavOptions();
        }
        if (changes?.apiName) {
            this.apiName = changes?.apiName?.currentValue;
            this.setDateFilters();
        }

        if (changes['filterByInput']) {
            this.filterBy = this.filterByInput ?? [];
            //Remove empty header columns
            if (this.filterBy?.length > 0) {
                this.filterBy = this.filterBy.filter(a => a.header != "" && a.header != null);
                this.groupByFilter = this.filterBy.filter(a => a.header != "" && a.header != null && !['Decimal', 'Number', 'Money', 'Percentage', 'Currency', 'Formula', 'RichText'].includes(a.fieldDataType));
            }
            this.filterByCopy = ParseHelper.DeepCopy(this.filterBy ?? []);
            this.groupByFilterCopy = ParseHelper.DeepCopy(this.groupByFilter ?? []);
        }

        if (changes['filterByInput']?.currentValue?.length == 0) {
            this.filterGroup = [];
        }

        if (changes.selectedFilterGroup && changes?.selectedFilterGroup?.currentValue?.length > 0) {
            this.filterGroup = changes?.selectedFilterGroup?.currentValue;
        }
        else if (changes.selectedFilterGroup && changes?.selectedFilterGroup?.currentValue?.length == 0) {
            this.filterGroup = [];
        }


        if (changes.customDateFilters && changes.customDateFilters.currentValue?.length > 0) {
            this.filterDataByTime = changes.customDateFilters.currentValue;
        } else if (changes.customDateFilters && changes.customDateFilters.currentValue?.length == 0) {
            this.setDateFilters();
        }

        if (changes.customSeletedDateFilter && changes.customSeletedDateFilter?.currentValue) {
            const customSeletedDateFilter = changes.customSeletedDateFilter?.currentValue;
            this.setDateFilters();
            this.selectedDateFilter = this.filterDataByTime.find(dList => dList.code == customSeletedDateFilter?.code);

            if (customSeletedDateFilter?.fromDate && customSeletedDateFilter?.toDate) {
                this.selectedDateFrom = customSeletedDateFilter?.fromDate;
                this.selectedDateTo = customSeletedDateFilter?.toDate;
            }
            this.changeRange();
        }

        // if(changes.filterPopupOnly){
        //     this.filterPopupOnly = changes.filterPopupOnly?.currentValue||false;
        // }

        if (changes.displayFilterPopup) {
            this.displayFilterPopup = changes.displayFilterPopup?.currentValue || false;
            this.setTempFilterValues();
        }

        if (changes.filterPopupHeader && changes.displayFilterPopup?.currentValue) {
            this.filterPopupHeader = changes.filterPopupHeader?.currentValue;
        }

        if (changes.opportunityChannelList && changes.opportunityChannelList.currentValue) {
            this.opportunityChannelList = changes.opportunityChannelList.currentValue;
        }

        if (changes.selectedOpportunityChannel && changes.selectedOpportunityChannel.currentValue) {
            this.selectedOpportunityChannel = changes.selectedOpportunityChannel.currentValue;
        }

        if (changes.filterByInputValue && changes.filterByInputValue.currentValue && this.enableAPIFilter == true) {
            if (this.editFlag) {
                this.changeFilterOptionsEdit(this.currentEditedFilter)
            } else {
                this.changeFilterOptions();
            }
        }

        if (changes.selectedTerritory && changes.selectedTerritory.currentValue) {
            this.selectedTerritory = changes.selectedTerritory.currentValue?.name ? changes.selectedTerritory.currentValue : null;
        }

        if (changes.territoryNamesList && changes.territoryNamesList.currentValue) {
            this.territoryNamesList = changes.territoryNamesList.currentValue;
        }
    }

    ngOnInit(): void {
        this.setDateFilters();
        this.selectedDateFilter = this.filterDataByTime[0];
        this.changeRange();
        this.generateMyFavOptions();
    }

    setDateFilters() {
        this.filterDataByTime = this.getDateFilters();
    }

    getDateFilters(): IDateFilterModel[] | any[] {
        if (this.apiName == "InventoryCustomers" || this.apiName == "InventoryVendor" || this.apiName == "inventory-aging") {
            let dataFilter = FINANCE_BALANCESHEET_DATE_RANGE_LIST
            return dataFilter;
        } else {
            let dataFilter: IDateFilterModel[] = this.customDateFilters.length > 0 ? this.customDateFilters : [
                { label: 'Today', code: 'today' },
                { label: 'Yesterday', code: 'yesterday' },
                { label: 'This Month', code: 'this month' },
                { label: 'Last Month', code: 'last month' },
                { label: 'Last 7 days', code: 'last 7 days' },
                { label: 'Last 15 days', code: 'last 15 days' },
                { label: 'Last 30 days', code: 'last 30 days' },
                { label: 'Last 60 days', code: 'last 60 days' },
                { label: 'Last 90 days', code: 'last 90 days' },
                { label: 'Custom Date', code: 'custom' },
            ];
            return dataFilter;
        }
    }
    //date range dropdown change
    public changeRange(emitChanges: boolean = true): void {

        let today = this.app._showDateTimeWithZone(new Date());
        let todayCopy = this.app._showDateTimeWithZone(new Date());

        if (this.apiName == "InventoryCustomers" || this.apiName == "InventoryVendor" || this.apiName == "inventory-aging") {
            let data = {
                code: this.selectedDateFilter.code == "custom" ? "Custom" : this.selectedDateFilter.code,
                fromDate: this.dateFrom,
                toDate: this.dateTo,
            };
            const dateRange = this.dateRangeFilterService.changeRange(data);
            this.dateFrom = dateRange?.fromDate;
            this.dateTo = dateRange?.toDate;
        } else {
            if (this.selectedDateFilter.code == 'today') {
                this.dateFrom = today;
                this.dateTo = today;
            } else if (this.selectedDateFilter.code == 'yesterday') {
                let yesterday = todayCopy;
                yesterday.setDate(todayCopy.getDate() - 1);

                this.dateFrom = yesterday;
                this.dateTo = yesterday;
            } else if (this.selectedDateFilter.code == 'this month') {
                let firstday = todayCopy;
                firstday.setDate(1);

                this.dateFrom = firstday;
                this.dateTo = today;
            } else if (this.selectedDateFilter.code == 'last month') {
                this.dateFrom = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                this.dateTo = new Date(today.getFullYear(), today.getMonth(), 0);
            } else if (this.selectedDateFilter.code == 'last 7 days') {
                let seven = todayCopy;
                seven.setDate(todayCopy.getDate() - 7);

                this.dateFrom = seven;
                this.dateTo = today;
            } else if (this.selectedDateFilter.code == 'last 15 days') {
                let fifteen = todayCopy;
                fifteen.setDate(todayCopy.getDate() - 15);

                this.dateFrom = fifteen;
                this.dateTo = today;
            } else if (this.selectedDateFilter.code == 'last 30 days') {
                let thirty = todayCopy;
                thirty.setDate(todayCopy.getDate() - 30);

                this.dateFrom = thirty;
                this.dateTo = today;
            } else if (this.selectedDateFilter.code == 'last 60 days') {
                let sixty = todayCopy;
                sixty.setDate(todayCopy.getDate() - 60);

                this.dateFrom = sixty;
                this.dateTo = today;
            } else if (this.selectedDateFilter.code == 'last 90 days') {
                let ninety = todayCopy;
                ninety.setDate(todayCopy.getDate() - 90);

                this.dateFrom = ninety;
                this.dateTo = today;
            } else if (this.selectedDateFilter.code == 'custom') {
                if (this.selectedDateFrom && this.selectedDateTo) {
                    this.dateFrom = new Date(this.selectedDateFrom);
                    this.dateTo = new Date(this.selectedDateTo);
                } else {
                    this.dateFrom = null;
                    this.dateTo = null;
                }
            } else {
                this.dateFrom = null;
                this.dateTo = null;
            }
        }

        //emit to parent
        if (((this.dateFrom && this.dateTo) || this.changeDateEnable) && emitChanges) {
            this.onChangeRange.emit({ dateFrom: this.dateFrom, dateTo: this.dateTo, selectedDateFilter: this.selectedDateFilter });
        }
        this.filterGroup = this.filterGroup?.filter(filters => filters?.notRemovable) || [];
        // console.log(today, this.dateFrom, this.dateTo);
    }
    public onSelectFromDate(e: any): void {
        this.minDate = e;

        if (this.dateFrom && this.dateTo) {
            //emit to parent
            this.onChangeRange.emit({ dateFrom: this.dateFrom, dateTo: this.dateTo, selectedDateFilter: this.selectedDateFilter });
        }
    }
    public onSelectToDate(e: any): void {
        if ((this.selectedDateFilter?.code?.toLowerCase() == 'custom' && this.dateTo)
            || (this.selectedDateFilter?.code?.toLowerCase() !== 'custom' && this.dateTo && this.dateFrom)) {
            //emit to parent
            this.onChangeRange.emit({ dateFrom: this.dateFrom, dateTo: this.dateTo, selectedDateFilter: this.selectedDateFilter });
        }
    }

    //date range dropdown change
    public changeDateOptionRange(): void {

        if (!this.selectedFilterOption?.code || !(this.selectedFilterBy?.dataType == 'date' && this.dateRangeForDatetime)) {
            return;
        }

        let today = new Date();
        let todayCopy = new Date();
        if (this.selectedFilterOption.code == 'all') {
            this.dateRangeFrom = null;
            this.dateRangeTo = null;
        }
        else if (this.selectedFilterOption.code == 'today') {
            this.dateRangeFrom = today;
            this.dateRangeTo = today;
        } else if (this.selectedFilterOption.code == 'yesterday') {
            let yesterday = todayCopy;
            yesterday.setDate(todayCopy.getDate() - 1);

            this.dateRangeFrom = yesterday;
            this.dateRangeTo = yesterday;
        } else if (this.selectedFilterOption.code == 'thismonth') {
            let firstday = todayCopy;
            firstday.setDate(1);

            this.dateRangeFrom = firstday;
            this.dateRangeTo = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        } else if (this.selectedFilterOption.code == 'lastmonth') {
            this.dateRangeFrom = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            this.dateRangeTo = new Date(today.getFullYear(), today.getMonth(), 0);
        } else if (this.selectedFilterOption.code == 'last7days') {
            let seven = todayCopy;
            seven.setDate(todayCopy.getDate() - 7);

            this.dateRangeFrom = seven;
            this.dateRangeTo = today;
        } else if (this.selectedFilterOption.code == 'last15days') {
            let fifteen = todayCopy;
            fifteen.setDate(todayCopy.getDate() - 15);

            this.dateRangeFrom = fifteen;
            this.dateRangeTo = today;
        } else if (this.selectedFilterOption.code == 'last30days') {
            let thirty = todayCopy;
            thirty.setDate(todayCopy.getDate() - 30);

            this.dateRangeFrom = thirty;
            this.dateRangeTo = today;
        } else if (this.selectedFilterOption.code == 'last60days') {
            let sixty = todayCopy;
            sixty.setDate(todayCopy.getDate() - 60);

            this.dateRangeFrom = sixty;
            this.dateRangeTo = today;
        } else if (this.selectedFilterOption.code == 'last90days') {
            let ninety = todayCopy;
            ninety.setDate(todayCopy.getDate() - 90);

            this.dateRangeFrom = ninety;
            this.dateRangeTo = today;
        } else {
            this.dateRangeFrom = null;
            this.dateRangeTo = null;
        }
    }

    public changeFilterOptions(loadFilterValue: boolean = false, resetData: boolean = false): void {
        if (loadFilterValue) {
            this.optionsFilter({ filter: "" });
        }

        let filterOptValue = [];
        filterOptValue = this.filterByInputValue?.map(x => { return { id: x?.id, name: x[this.selectedFilterBy?.field] } })?.map((y, i) => ({ id: i + 1, selectedId: y?.id, name: y.name })) ?? [];
        if (this.selectedFilterBy?.dataType == 'date' && !this.dateRangeForDatetime) {
            filterOptValue = filterOptValue?.map(x => {
                return {
                    id: x.id,
                    name: (x.name?.includes('T') && !this.selectedFilterBy?.isCustom) ? this.localDatePipe.transform(x.name, 'MM/DD/YYYY') : this.datePipe.transform(x.name, 'MM/dd/yyyy')
                };
            });
            filterOptValue = filterOptValue?.sort((a, b) => (a.name > b.name) ? -1 : 1);
        } else if (this.selectedFilterBy?.dataType == 'date' && this.dateRangeForDatetime) {
            filterOptValue = DateTimeOperatorValue.map((x, i) => { return { id: i + 1, name: x.label, code: x.code } });
        }

        //group by
        this.filterOptions = [...new Map(filterOptValue.map(item => [item['name'], item])).values()];
        //remove empty
        this.filterOptions = this.filterOptions.filter(d => (d.name != "" && d.name != null) || (d.nam == 0 || d.name == '0'));

        if (!(this.selectedFilterBy?.dataType == 'date' && this.dateRangeForDatetime)) {
            this.filterOptions = this.filterOptions.sort((a, b) => b.name > a.name ? -1 : 1);
        }
        this.vertualFilterOptions = this.filterOptions.slice(0, 200);

        if (resetData) {
            this.selectedFilterOption = null;
        } else {
            if (this.multiSelectFilter && this.selectedFilterBy?.dataType != 'date' && this.selectedFilterOption?.length > 0) {
                this.selectedFilterOption.map(selected => {
                    const exist = this.vertualFilterOptions?.find(n => n?.name == selected?.name);
                    if (!exist) {
                        this.vertualFilterOptions.unshift(selected);
                    }
                })

            } else {
                const exist = this.vertualFilterOptions?.find(n => n?.name == this.selectedFilterOption?.name);
                if (!exist) { this.selectedFilterOption = null; }
            }
        }

    }
    //for edit
    public changeFilterOptionsEdit(s: IReportsFilterModel, loadFilterValue: boolean = false, resetData: boolean = false): void {

        if (loadFilterValue) {
            this.optionsFilter({ filter: "" }, true);
        }

        if (resetData) {
            if (s?.multiSelect) {
                this.filterOptions = [];
                s.values?.map((ms, index) => {
                    this.filterOptions.push({ id: s.nameIds[index], selectedId: s.selectedIds[index], name: ms, code: s?.rangeCode })
                })
            } else {
                this.filterOptions = [{ id: s.nameId, selectedId: s.selectedId, name: s.value, code: s?.rangeCode }];
            }

            if (s?.multiSelect) {
                this.selectedFilterOption = this.filterOptions.filter(ele => s.values.includes(ele.name));
            } else {
                this.selectedFilterOption = this.filterOptions.filter(ele => ele.id == s.nameId)[0];
            }
        }

        let filterOptValue = [];
        filterOptValue = this.filterByInputValue?.map(x => { return { id: x?.id, name: x[this.selectedFilterBy?.field] } })?.map((y, i) => ({ id: i + 1, selectedId: y?.id, name: y.name })) ?? [];
        if (this.selectedFilterBy?.dataType == 'date' && !this.dateRangeForDatetime) {
            filterOptValue = filterOptValue?.map(x => {
                return {
                    id: x.id,
                    name: (x.name?.includes('T') && !this.selectedFilterBy?.isCustom) ? this.localDatePipe.transform(x.name, 'MM/DD/YYYY') : this.datePipe.transform(x.name, 'MM/dd/yyyy')
                };
            });
            filterOptValue = filterOptValue?.sort((a, b) => (a.name > b.name) ? -1 : 1);
        } else if (this.selectedFilterBy?.dataType == 'date' && this.dateRangeForDatetime) {
            filterOptValue = DateTimeOperatorValue.map((x, i) => { return { id: i + 1, name: x.label, code: x.code } });

            if (s?.dateRangeFrom && s?.dateRangeTo) {
                this.dateRangeFrom = new Date(s.dateRangeFrom);
                this.dateRangeTo = new Date(s.dateRangeTo);
            }
        }
        //group by
        let filtOpts = [...new Map(filterOptValue.map(item => [item['name'], item])).values()];
        filtOpts = filtOpts?.filter(x => !this.filterOptions.find(ex => ex.name == x.name));
        this.filterOptions.push(...filtOpts);
        this.filterOptions = this.filterOptions.filter(d => (d.name != "" && d.name != null) || (d.nam == 0 || d.name == '0'));
        this.vertualFilterOptions = this.filterOptions.slice(0, 200);

        if (!resetData) {
            if (this.multiSelectFilter && this.selectedFilterBy?.dataType != 'date' && this.selectedFilterOption?.length > 0) {
                this.selectedFilterOption.map(selected => {
                    const exist = this.vertualFilterOptions?.find(n => n?.name == selected?.name);
                    if (!exist) {
                        this.vertualFilterOptions.unshift(selected);
                    }
                })
            }
        }
    }

    public changeFilterOptionValue($event: any) {
        this.changeDateOptionRange();
    }

    public optionsFilter($event: any, forceApiCall: boolean = false) {
        const searchValue = $event.filter;
        this.optionFilterText = ParseHelper.DeepCopy(searchValue);
        if ((this.enableAPIFilter == true && (this.addFilter == true || forceApiCall)) && !(this.selectedFilterBy?.dataType == 'date' && this.dateRangeForDatetime)) {
            const filterGroup = (this.editFlag && this.currentEditedFilter?.field) ? this.filterGroup.filter(g => g.field != this.currentEditedFilter.field) : this.filterGroup;
            this.onOptionsFilter.emit({ searchValue: searchValue || null, selectedFilter: this.selectedFilterBy, selectedFilters: filterGroup });
        }
        else {
            let filteredOptions = [];
            if (searchValue?.length > 0) {
                filteredOptions = this.filterOptions.filter(option => option?.name?.toString()?.toLowerCase()?.includes(searchValue?.toString()?.toLowerCase()));
            } else {
                filteredOptions = this.filterOptions;
            }
            this.vertualFilterOptions = filteredOptions.slice(0, 200);
        }
    }

    public onShowFilter($event: any) {
        const filterValue = { filter: this.optionFilterText }
        this.optionsFilter(filterValue);
    }

    public applyFilter(): void {
        this.modifyColumnFilterBy();
        this.optionFilterText = "";
        this.filterId = this.filterId + 1;
        if (this.selectedFilterBy?.header == 'Category') {
            this.showSub = true;
        }

        const multiValues = {
            multiSelect: false,
            values: [],
            selectedIds: [],
            nameIds: []
        }

        if (this.selectedFilterOption?.length > 0) {
            multiValues.multiSelect = true;
            this.selectedFilterOption.map(value => {
                multiValues.values.push(value.name);
                multiValues.selectedIds.push(value.selectedId);
                multiValues.nameIds.push(value.id);
            })
        }

        let eachFilter: IReportsFilterModel = {
            id: this.filterId,
            field: this.selectedFilterBy?.field,
            categoryId: this.selectedFilterBy?.id,
            category: this.selectedFilterBy?.header,
            selectedId: this.selectedFilterOption?.selectedId,
            nameId: this.selectedFilterOption?.id,
            value: this.selectedFilterOption?.name,
            dataType: this.selectedFilterBy?.dataType,
            fieldDataType: this.selectedFilterBy?.fieldDataType,
            isDateWithTime: this.selectedFilterBy?.isDateWithTime || false,
            dateRangeTo: this.dateRangeTo,
            dateRangeFrom: this.dateRangeFrom,
            rangeCode: this.selectedFilterOption?.code || "",
            fieldNameDB: this.selectedFilterBy?.fieldNameDB,
            isCustom: this.selectedFilterBy?.isCustom ?? false,
            isCommaSeperated: this.selectedFilterBy?.isCommaSeperated,
            previewValue: "",
            ...multiValues
        }
        eachFilter.previewValue = this.generateFilterValuePreview(eachFilter);
        this.filterGroup.push(eachFilter);
        //emit to parent
        this.onApplyFilter.emit(this.filterGroup);
        this.closePanel();
    }
    public closePanel(): void {
        this.selectedFilterBy = null;
        this.selectedFilterOption = null;
        this.selectedAggregateBy = [];
        this.selectedAggregateTypeBy = this.aggregateTypes[0];
        this.selectedGroupBy = null;
        this.selectedSubGroupBy = null;
        this.optionFilterText = "";
        this.selectedOrderByType = null;
        this.selectedOrderField = null;
        this.topNumberOfRecords = null;
        this.topNumberOfRecordsDisabled = false;
        this.op.hide();
        this.onClosePanel.emit();
    }
    public removeFilter(s: any, index: any): void {
        if (s?.category == 'Category') {
            this.showSub = false;
        }
        this.filterGroup.splice(index, 1);
        this.onRemoveFilter.emit(this.filterGroup);
        this.modifyColumnFilterBy();
    }
    public editFilter(s: IReportsFilterModel): void {
        //SavedSearch Edit Filter Flag
        this.editFlag = true;
        this.currentEditedFilter = s;
        //emit to parent
        this.onModifyFilterOptions.emit(this.filterGroup);
        this.selectedFilterBy = this.filterByCopy.filter(ele => ele.id == s.categoryId)[0];
        //for edit
        this.modiColumnFilterByOnEdit(s);

        setTimeout(() => {
            this.changeFilterOptionsEdit(s, true, true);
        }, 100);
        this.filterTemp = JSON.parse(JSON.stringify(s));
        this.op.show(event);
    }
    public saveFilter(): void {
        const multiValues = {
            multiSelect: false,
            values: [],
            selectedIds: [],
            nameIds: []
        }

        if (this.selectedFilterOption?.length > 0) {
            multiValues.multiSelect = true;
            this.selectedFilterOption.map(value => {
                multiValues.values.push(value.name);
                multiValues.selectedIds.push(value.selectedId);
                multiValues.nameIds.push(value.id);
            })
        }

        let filter = {
            id: this.filterTemp.id,
            field: this.selectedFilterBy?.field,
            categoryId: this.selectedFilterBy?.id,
            category: this.selectedFilterBy?.header,
            selectedId: this.selectedFilterOption?.selectedId,
            nameId: this.selectedFilterOption?.id,
            notRemovable: this.filterTemp?.notRemovable,
            value: this.selectedFilterOption?.name,
            dataType: this.selectedFilterBy?.dataType,
            fieldDataType: this.selectedFilterBy?.fieldDataType,
            isDateWithTime: this.selectedFilterBy?.isDateWithTime || false,
            dateRangeTo: this.dateRangeTo,
            dateRangeFrom: this.dateRangeFrom,
            rangeCode: this.selectedFilterOption?.code || "",
            isCustom: this.selectedFilterBy?.isCustom ?? false,
            isCommaSeperated: this.selectedFilterBy?.isCommaSeperated,
            previewValue: "",
            ...multiValues
        }
        filter.previewValue = this.generateFilterValuePreview(filter);
        let arr = []
        for (let s of this.filterGroup) {
            if (s.id == filter.id) {
                s = JSON.parse(JSON.stringify(filter));
            }
            arr.push(s);
        }
        this.filterGroup = JSON.parse(JSON.stringify(arr));
        this.onRemoveFilter.emit(this.filterGroup);
        this.closePanel();
    }

    generateFilterValuePreview(eachFilter: IReportsFilterModel) {
        let previewValue = eachFilter.value;
        if (eachFilter?.multiSelect) {
            const formatedValues = [];
            eachFilter.values.map(value => {
                formatedValues.push(this.getFilterFormatedValuePreview(eachFilter, value));
            });

            previewValue = formatedValues.join(', ');
        } else {
            previewValue = this.getFilterFormatedValuePreview(eachFilter, eachFilter.value);
        }
        return previewValue;
    }

    getFilterFormatedValuePreview(eachFilter: IReportsFilterModel, value: any) {
        switch (eachFilter?.dataType) {
            case 'datetime':
                return this.localDatePipe.transform(value);
            case 'timespan':
                return this.timeConvert.transform(value);
            case 'secsdhms':
                return this.secsToDhms.transform(value);
            case 'currencySymbol':
                return this.currencySymbol.transform(value);
            case 'percentageSymbol':
                return this.percentageSymbol.transform(value);
            default:
                return value;
        }
    }

    public modifyColumnFilterBy(): void {
        this.filterBy = ParseHelper.DeepCopy(this.filterByCopy);
        this.groupByFilter = ParseHelper.DeepCopy(this.groupByFilterCopy);
        this.filterOptions = [];
        this.vertualFilterOptions = [];
        if (this.filterGroup?.length > 0) {
            this.filterBy = this.filterBy.filter(x => !this.filterGroup.map(y => y.field).includes(x.field));
        }
    }
    //for edit
    public modiColumnFilterByOnEdit(s: any): void {
        this.onModifyFilterOptions.emit([...this.filterGroup.filter(x => x.field != s.field)] ?? []);
        this.filterBy = ParseHelper.DeepCopy(this.filterByCopy);
        this.groupByFilter = ParseHelper.DeepCopy(this.groupByFilterCopy);
        this.filterOptions = [];
        this.vertualFilterOptions = [];
        if (this.filterGroup?.length > 0) {
            this.filterBy = this.filterBy.filter(x => !this.filterGroup.map(y => y.field).includes(x.field) || x.field == s.field);
        }
    }

    //Channel Selection
    changeChannel($event) {
        this.filterGroup = []; //clear added filter if channel changed
        this.onChangeChannel.emit(this.selectedChannel);
    }

    changeModule($event) {
        this.filterGroup = []; //clear added filter if module changed
        this.onChangeModule.emit(this.selectedModule);
    }

    changeOpportunityChannel($event) {
        this.filterGroup = []; //clear added filter if channel changed
        this.onOpportunityChangeChannel.emit(this.selectedOpportunityChannel);
    }

    onChangeWarehouseLocation($event: any): void {
        this.filterGroup = []; //clear added filter if Warehouse Location changed
        this.onWarehouseLocation.emit(this.selectedWarehouseLocation);
    }

    //My Fav
    generateMyFavOptions() {
        const addedFav = this.myFavList.filter(fav => fav.reportType == this.selectedWindow);

        this.fav = [
            { id: 0, name: "Select Fav" }
        ];

        addedFav?.map(myfav => {
            this.fav.push({
                id: myfav.id,
                name: myfav.favTitle
            })
        });
    }

    changeFav(e) {
        const mainReportType = this.reportsMenusFlat.find(menu => menu.reportType == this.selectedWindow);
        if (e.value.id == 0) {
            // this.selectedGroup = null;
            // this.reportName = null;
            // this.displayAddFav = true;
            this.filterGroup = [];
            this.onRemoveFilter.emit(this.filterGroup);
            if (mainReportType?.parent) {
                this.navigateToReport(mainReportType.parent.route, mainReportType.route);
            }
        } else {
            if (mainReportType?.parent) {
                this.navigateToReport(mainReportType.parent.route, mainReportType.route, { myfav: e.value.id });
            }

        }
    }
    saveFav(r) {
        let newFav = {
            id: this.fav.length + 1,
            name: r
        }
        this.fav.push(newFav)
        this.displayAddFav = false;
    }
    changeGroup(e) {
        if (e.value.id == 1) {
            this.groupName = null;
            this.displayAddGroup = true;
        }
    }
    saveGroup(g) {
        let newGroup = {
            id: this.groups.length + 1,
            name: g
        }
        this.groups.push(newGroup)
        this.displayAddGroup = false;
    }

    navigateToReport(report: string, path: string, queryParams: any = null) {
        this.router.navigate([`/reports/${report}`, path], { queryParams: queryParams });
    }

    setTempFilterValues() {
        this.tempFiltersValues = {
            dateFilter: this.selectedDateFilter,
            fromDate: this.dateFrom,
            toDate: this.dateTo,
            opportunityChannel: this.selectedOpportunityChannel,
            channel: this.selectedChannel,
            warehouseLocation: this.selectedWarehouseLocation,
        }
    }

    restoreFilterValues() {
        this.selectedDateFilter = this.tempFiltersValues?.dateFilter;
        this.dateFrom = this.tempFiltersValues?.fromDate;
        this.dateTo = this.tempFiltersValues?.toDate;
        this.selectedOpportunityChannel = this.tempFiltersValues?.opportunityChannel;
        this.selectedChannel = this.tempFiltersValues?.channel;
        this.selectedWarehouseLocation = this.tempFiltersValues?.warehouseLocation;
    }

    cancelFilterPopup() {
        this.restoreFilterValues();
        this.closeFilterPopup();
    }

    closeFilterPopup() {
        this.displayFilterPopup = false;
        this.onCloseFilterPopup.emit(false);
    }

    applyAllFilters(applyMode: typeReportsAllFiltersApplyModes) {
        let allFiltersValue: ReportsAllFiltersAppyModels = {
            applyMode: applyMode,
            dateFilter: {
                label: this.selectedDateFilter?.label,
                code: this.selectedDateFilter?.code,
                fromDate: this.dateFrom,
                toDate: this.dateTo
            },
            opportunityChannel: this.selectedOpportunityChannel,
            channel: this.selectedChannel,
            selectedTerritory: this.selectedTerritory
        }
        this.onAllFilterApply.emit(allFiltersValue);
        this.closeFilterPopup();
    }

    onChangeGroupBy() {
        if (!this.selectedGroupBy) {
            this.selectedSubGroupBy = null;
        }
        this.aggregateFields = this.filterBy.filter(fld => ['Number', 'Decimal', 'Currency', 'Money'].includes(fld.fieldDataType));
        this.setAggTypes();
    }

    setAggTypes() {
        this.aggregateTypesCopy = ParseHelper.DeepCopy(this.aggregateTypes);
        if (this.aggregateFields?.length == 0 || this.selectedAggregateBy?.length == 0) {
            this.selectedAggregateTypeBy = this.aggregateTypesCopy?.filter(type => type.code == 'Count')[0];
        } else {
            const countType = this.aggregateTypesCopy.filter(type => type.code == 'Count')[0];
            const index = this.aggregateTypesCopy.indexOf(countType);
            this.aggregateTypesCopy.splice(index, 1);
            this.selectedAggregateTypeBy = this.aggregateTypesCopy.find(type => type.code == this.selectedAggregateTypeBy?.code) || this.aggregateTypesCopy[0];
        }

    }

    setGroupByFilter() {
        // console.log(this.savedGroup)
        this.aggregateFields = this.filterBy.filter(fld => ['Number', 'Decimal', 'Currency', 'Money'].includes(fld.fieldDataType));
        if (this.savedGroup) {
            const filteredGroupBy = this.groupByFilter?.filter(fld => fld.field == this.savedGroup?.groupBy?.columnName)[0];
            if (filteredGroupBy) {
                this.selectedGroupBy = filteredGroupBy;
            }

            const filteredSubGroupBy = this.groupByFilter?.filter(fld => fld.field == this.savedGroup?.subGroupBy?.columnName)[0];
            if (filteredSubGroupBy) {
                this.selectedSubGroupBy = filteredSubGroupBy;
            }

            const aggFields = [];
            this.savedGroup.aggregatedFields?.forEach(element => {
                const filteredAggField = this.aggregateFields?.filter(fld => fld.field == element.columnName)[0];
                if (filteredAggField) {
                    aggFields.push(filteredAggField);
                }
            });
            this.selectedAggregateBy = aggFields;
            this.setAggTypes()
            const filteredAggType = this.savedGroup?.aggregatedFields?.length > 0 ? this.aggregateTypesCopy?.filter(fld => fld.code == this.savedGroup.aggregatedFields[0].aggregationType)[0] : null;
            if (filteredAggType) {
                this.selectedAggregateTypeBy = filteredAggType;
            }
        }
    }

    applyGroup() {
        const groupBy = this.selectedGroupBy?.field ? {
            labelName: this.selectedGroupBy?.header,
            columnName: this.selectedGroupBy?.field,
            dataType: this.selectedGroupBy?.fieldDataType,
            isDateWithTime: this.selectedGroupBy?.isDateWithTime || false,
            isCsv: this.selectedGroupBy?.isCsv || false,
            isCustom: this.selectedGroupBy?.isCustom
        } : null;

        const subGroupBy = this.selectedSubGroupBy?.field ? {
            labelName: this.selectedSubGroupBy?.header,
            columnName: this.selectedSubGroupBy?.field,
            dataType: this.selectedSubGroupBy?.fieldDataType,
            isDateWithTime: this.selectedSubGroupBy?.isDateWithTime || false,
            isCsv: this.selectedSubGroupBy?.isCsv || false,
            isCustom: this.selectedSubGroupBy?.isCustom
        } : null;

        const groupByObj = {
            groupBy: groupBy,
            subGroupBy: subGroupBy,
            aggregatedFields: (this.selectedAggregateBy?.length > 0 ? this.setAggregateData() :
                [{ columnName: this.selectedGroupBy?.field, aggregationType: this.selectedAggregateTypeBy?.code, dataType: this.selectedGroupBy.fieldDataType, isHandledFromUI: false }])
        }
        this.onGroupByFilter.emit(groupByObj);
        this.groupBy.hide();
    }

    resetGroup() {
        this.selectedGroupBy = null;
        this.selectedSubGroupBy = null;
        this.selectedAggregateBy = [];
        this.selectedAggregateTypeBy = this.aggregateTypes[0];
        this.onResetGroupByFilter.emit();
        this.groupBy.hide();
    }

    setAggregateData() {
        const aggregatedFields = [];
        for (let fld of this.selectedAggregateBy) {
            const obj = {
                columnName: fld.field,
                aggregationType: this.selectedAggregateTypeBy?.code,
                dataType: fld.fieldDataType,
                isHandledFromUI: fld.isCommaSeperated
            }
            aggregatedFields.push(obj);
        }
        return aggregatedFields;
    }

    setSavedOrderBy() {
        if (this.savedOrderBy) {
            const filteredOrderBy = this.filterBy?.find(fld => fld.field == this.savedOrderBy?.columnName);
            if (filteredOrderBy) {
                this.selectedOrderField = filteredOrderBy;
            }
            this.selectedOrderByType = this.orderByTypes.find(o => o.isDescending === this.savedOrderBy?.isDescending);
            this.topNumberOfRecords = this.savedOrderBy?.limit || null;
        } else {
            this.selectedOrderByType = this.orderByTypes.find(o => o.isDescending === true);
        }

        this.checkTopNumberOfRecordsDisabled();
    }

    resetOrderBy() {
        this.selectedOrderByType = null;
        this.selectedOrderField = null;
        this.topNumberOfRecords = null;
        this.topNumberOfRecordsDisabled = false;
        this.onResetOrderByFilter.emit();
        this.orderBy.hide();
    }

    applyOrderBy() {
        const orderByObj = {
            columnName: this.selectedOrderField?.field,
            dataType: this.selectedOrderField?.fieldDataType,
            isDescending: this.selectedOrderByType?.isDescending,
            limit: this.topNumberOfRecords || null
        }
        this.onOrderByFilter.emit(orderByObj);
        this.orderBy.hide();
    }

    checkTopNumberOfRecordsDisabled() {
        if (this.savedGroup && (this.savedGroup?.aggregatedFields?.length > 0 || this.savedGroup?.groupBy?.columnName)) {
            const exist = this.savedGroup?.aggregatedFields?.find(cl => cl.columnName == this.selectedOrderField?.field);
            this.topNumberOfRecordsDisabled = !((this.savedGroup?.groupBy?.columnName == this.selectedOrderField?.field) || exist) as boolean;
            if (this.topNumberOfRecordsDisabled) {
                this.topNumberOfRecords = null;
            }
        } else {
            this.topNumberOfRecordsDisabled = false;
        }
    }

    onGroupByClick(groupByPanel: any, $event) {
        groupByPanel.toggle($event);
        this.setGroupByFilter();
        setTimeout(() => {
            this.setGroupByFilter();
        }, 300)
    }

    onOrderByClick(orderByPanel: any, $event) {
        orderByPanel.toggle($event);
        this.setSavedOrderBy();
        setTimeout(() => {
            this.setSavedOrderBy();
        }, 300)
    }

    changeTerritory(event) {
        if (!event.node.objectId) {
            setTimeout(() => {
                this.selectedTerritory = this.oldSelectedTerritory ? this.oldSelectedTerritory : null;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Root Territory Not Selectable!' });
            }, 200)
            return;
        }
        this.selectedTerritory = event.node;
        this.oldSelectedTerritory = this.selectedTerritory;
        this.onSelectedTerritory.emit(this.selectedTerritory);
    }
}
